import React, { useMemo } from "react";
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";

const ComparisonBarChart = ({ 
  categoryList1 = [], 
  categoryList2 = [], 
  company1Name = "Company 1", 
  company2Name = "Company 2",
  company1TotalReviews = 0,
  company2TotalReviews = 0,
  height = 400 
}) => {
  const chartOptions = useMemo(() => {
    // Get unique categories from both lists
    const allCategories = new Set([
      ...(categoryList1 || []).map(item => item.name),
      ...(categoryList2 || []).map(item => item.name)
    ]);
    
    const categories = Array.from(allCategories).sort();
    
    const company1Data = categories.map(category => {
      const item = (categoryList1 || []).find(cat => cat.name === category);
      return item ? Number(item.value) : 0;
    });
    
    const company2Data = categories.map(category => {
      const item = (categoryList2 || []).find(cat => cat.name === category);
      return item ? Number(item.value) : 0;
    });

    return {
      chart: {
        type: 'column',
        height: height,
        backgroundColor: 'transparent',
        style: {
          fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif'
        }
      },
      title: {
        text: null
      },
      xAxis: {
        categories: categories,
        crosshair: false,
        labels: {
          rotation: -45,
          style: {
            fontSize: '12px',
            color: '#666'
          }
        },
        lineColor: '#e8e8e8',
        tickColor: '#e8e8e8'
      },
      yAxis: {
        min: 0,
        title: {
          text: 'Percentage (%)',
          style: {
            fontSize: '12px',
            color: '#666',
            fontWeight: '500'
          }
        },
        labels: {
          style: {
            fontSize: '12px',
            color: '#666'
          }
        },
        gridLineColor: '#f0f0f0'
      },
      tooltip: {
        headerFormat: '<span style="font-size:12px; font-weight: 600">{point.key}</span><br/>',
        pointFormat: '<span style="color:{series.color}">{series.name}</span>: <b>{point.y:.1f}%</b><br/>',
        shared: false,
        backgroundColor: 'rgba(255, 255, 255, 0.95)',
        borderColor: '#ccc',
        borderRadius: 6,
        shadow: true,
        formatter: function() {
          return `<span style="font-size:12px; font-weight: 600">${this.x}</span><br/>` +
                 `<span style="color:${this.series.color}">${this.series.userOptions.displayName}</span>: <b>${this.y.toFixed(1)}%</b>`;
        }
      },
      plotOptions: {
        column: {
          pointPadding: 0.1,
          borderWidth: 0,
          groupPadding: 0.1,
          shadow: false,
          dataLabels: {
            enabled: true,
            inside: true,
            style: {
              fontSize: '11px',
              fontWeight: 'bold',
              color: 'white',
              textOutline: 'none'
            },
            formatter: function() {
              return this.y > 0 ? Math.round(this.y).toString() + '%' : '';
            }
          },
          states: {
            hover: {
              enabled: false 
            },
            select: {
              enabled: false
            }
          }
        }
      },
      legend: {
        align: 'right',
        verticalAlign: 'top',
        layout: 'horizontal',
        floating: false,
        backgroundColor: 'transparent',
        itemStyle: {
          fontSize: '12px',
          color: '#666',
          fontWeight: '500'
        },
        itemHoverStyle: {
          color: '#333'
        },
        itemMarginRight: 20,
        symbolPadding: 5
      },
      series: [
        {
          name: `${company1Name} (${company1TotalReviews} Reviews)`,
          displayName: company1Name,
          data: company1Data,
          color: '#481a6c'
        },
        {
          name: `${company2Name} (${company2TotalReviews} Reviews)`,
          displayName: company2Name, 
          data: company2Data,
          color: '#481A6C99'
        }
      ],
      credits: {
        enabled: false
      },
      exporting: {
        enabled: false
      },
      navigation: {
        buttonOptions: {
          enabled: false
        }
      },
      responsive: {
        rules: [{
            
          condition: {
            maxWidth: 768
          },
          chartOptions: {
            chart:{

                type:'bar',
                height: 1000 
            },
            legend: {
              layout: 'horizontal', 
              align: 'right',
              verticalAlign: 'top',
              itemStyle: {
                fontSize: '10px'
              }
            },
            xAxis: {
              labels: {
                style: {
                  fontSize: '10px'
                },
                step: 1,    
                allowOverlap: false
              }
            },
            yAxis: {
              labels: {
                style: {
                  fontSize: '10px'
                }
              },
              title: {
                style: {
                  fontSize: '10px'
                }
              }
            },
            plotOptions: {
                bar: {
                  dataLabels: {
                    enabled: true,
                    style: {
                      fontSize: '10px',
                      fontWeight: 'bold',
                      color: 'white',
                      textOutline: 'none'
                    },
                    inside: true,
                    overflow: 'justify',
                    crop: false,
                    formatter: function() {
                      return this.y > 0 ? Math.round(this.y).toString()  + '%' : '';
                    }
                  },
                  pointPadding: 0.1,
                  borderWidth: 0,
                  groupPadding: 0.1,
                  shadow: false,
                  states: {
                    hover: {
                      enabled: false
                    },
                    select: {
                      enabled: false
                    }
                  }
                }
              }
            }
          }]
        }
    };
  }, [categoryList1, categoryList2, company1Name, company2Name, company1TotalReviews, company2TotalReviews, height]);
  return (
    <div style={{ width: '100%', height: '100%' }}>
      <HighchartsReact
        highcharts={Highcharts}
        options={chartOptions}
      />
    </div>
  );
};

export default ComparisonBarChart;